import * as React from 'react';
import { BaseThemeProvider, createGlobalStyle } from '../styled';
import { BaseTheme, reset } from '../theme';
export var LucidGlobalStyle = createGlobalStyle(function (_ref) {
  var theme = _ref.theme;
  return [reset, "\n    body {\n      font-size: ".concat(theme.typography.content.fontSize, ";\n      font-weight: ").concat(theme.fontWeights.regular, ";\n      font-family: ").concat(theme.fontFamilies.default, ";\n      color: ").concat(theme.colors.text, ";\n      background: ").concat(theme.colors.background, ";\n      box-sizing: border-box;\n      padding: 0;\n      margin: 0;\n    }\n    *, *::after, *::before {\n      box-sizing: inherit;\n    }\n  ")];
});
/**
 * This provider should be used by every Lucidium based application.
 * It provides default styles.
 */

export var LucidiumProvider = function LucidiumProvider(_ref2) {
  var children = _ref2.children,
      _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? BaseTheme : _ref2$theme;
  return React.createElement(BaseThemeProvider, {
    theme: theme
  }, React.createElement(React.Fragment, null, React.createElement(LucidGlobalStyle, null), children));
};